import { useRouteMatch, Switch, Route, useHistory } from "react-router";
import { LoadingPage } from "../../EligibilityCheckerGeneric";
import Disabilities from "./Disabilities";
import DisabilityRegister from "./DisabilityRegister";
import { EligibilityCheckerQuestionsProps, ProgrammeProps } from "../Props";
import { Disability } from "../../../../types/ProfileViewModel";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../../redux/slices/progressBarSlice";

export interface DisabilitiesPageData {
  questions: EligibilityCheckerQuestionsProps[];
  loadingScreen: { title: string; body: string };
}

export interface DisabilitiesProps extends ProgrammeProps {
  disabilitiesPageData: DisabilitiesPageData;
  nextStepUrl: string;
  disabilities?: Disability[];
}
function DisabilitiesRoot({
  programmeTitle,
  disabilitiesPageData,
  nextStepUrl,
  disabilities,
  progressPercentage,
}: Readonly<DisabilitiesProps & { progressPercentage?: PowerOfTen }>) {
  let { path } = useRouteMatch();
  const history = useHistory();

  const dispatch = useDispatch();

  useEffect(() => {
    if (progressPercentage)
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
  }, [dispatch, progressPercentage]);

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <Disabilities
          programmeTitle={programmeTitle}
          disabilitiesPageData={disabilitiesPageData}
          nextStepUrl={nextStepUrl}
          disabilities={disabilities}
        />
      </Route>
      <Route exact path={`${path}/disability-register`}>
        <DisabilityRegister
          programmeTitle={programmeTitle}
          disabilitiesPageData={disabilitiesPageData}
          nextStepUrl={nextStepUrl}
        />
      </Route>
      <Route exact path={`${path}/loading`}>
        <LoadingPage
          callback={() => history.replace(nextStepUrl)}
          heading={disabilitiesPageData?.loadingScreen.title ?? ""}
          text={disabilitiesPageData?.loadingScreen.body ?? ""}
        />
      </Route>
    </Switch>
  );
}

export default DisabilitiesRoot;
